import { gql } from '@apollo/client';
import { TAG_FIELDS } from '@/graphql/fragments/tags';

export const GET_ORG_TAGS = gql`
    ${TAG_FIELDS}
    query GetOrgTags($organization_id: uuid!) {
        tags(where: { organization_id: { _eq: $organization_id } }) {
            ...TagFields
        }
    }
`;
